import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import MultilineTextArea from './FormTextField-components/MultilineTextArea';
import TextInput from './FormTextField-components/TextInput';

FormTextField.propTypes = {
    fieldName: PropTypes.string,
    focusedField: PropTypes.string,
    setFocusedField: PropTypes.func,
    multiline: PropTypes.bool,
    placeholder: PropTypes.string,
    validation: PropTypes.shape({
        required: PropTypes.bool,
        minLength: PropTypes.number,
        pattern: PropTypes.shape({
            value: PropTypes.string,
            message: PropTypes.string,
        }),
        validate: PropTypes.func,
    }),
    disabled: PropTypes.bool,
};

export default function FormTextField({
    fieldName,
    focusedField,
    setFocusedField,
    validation,
    disabled = false,
    multiline = false,
    placeholder = '',
}) {
    const { control } = useFormContext();

    return (
        <Controller
            name={fieldName}
            control={control}
            rules={{
                required: validation?.required ? 'This field is required' : undefined,
                minLength: validation?.minLength ?? undefined,
                pattern: validation?.pattern
                    ? {
                        value: new RegExp(validation?.pattern.value),
                        message: validation?.pattern.message,
                    }
                    : undefined,
                validate: validation?.validate ?? undefined,
            }}
            render={() => {
                const InputComponent = multiline ? MultilineTextArea : TextInput;

                return (
                    <InputComponent
                        fieldName={fieldName}
                        focusedField={focusedField}
                        setFocusedField={setFocusedField}
                        validation={validation}
                        disabled={disabled}
                        placeholder={placeholder}
                    />
                );
            }}
        />
    );
}
